import moment from 'moment'

import { doDownload } from '@/utils/doDownload'

export const downloadCanvasQRCode = () => {
  const svgElement = document
    .getElementById('my_qrcode')
    ?.querySelector<SVGSVGElement>('svg')

  if (svgElement) {
    try {
      const svgData = new XMLSerializer().serializeToString(svgElement)
      const svgBlob = new Blob([svgData], {
        type: 'image/svg+xml;charset=utf-8',
      })

      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const img = new Image()

      const svgUrl = URL.createObjectURL(svgBlob)

      img.onload = () => {
        canvas.width = img.width
        canvas.height = img.height

        if (ctx) {
          ctx.drawImage(img, 0, 0)
          const url = canvas.toDataURL()
          doDownload(
            url,
            `QRCode-${moment().format('MM-DD-YYYY-HH-mm-ss')}.png`
          )
        }

        URL.revokeObjectURL(svgUrl)
      }

      img.src = svgUrl
    } catch (error) {
      // Silently handle error
    }
  }
}
